module.exports = __webpack_public_path__ + "static/media/7.1dd84b51.png";